export default __webpack_public_path__ + "static/media/purchasedIcon.482819f7.svg";